import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChange, ElementRef } from '@angular/core';
import { PageContentService } from '@app/services/help/pagecontent.service';
import { debounceTime } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { PageContent } from '@app/models/help/pagecontent.model';

declare var $: any;

@Component({
  selector: 'app-navsearch',
  templateUrl: './navsearch.component.html',
  styleUrls: ['./navsearch.component.scss']
})
export class NavsearchComponent implements OnInit, OnChanges {
  @Input()
  public visible: boolean;
  @Output()
  public onclose = new EventEmitter<boolean>();
  public queryField: FormControl = new FormControl();
  public searchResults: PageContent[] = null;
  public searching: boolean = false;

  constructor(
    private router: Router,
    public elem: ElementRef,
    private pageContentService: PageContentService) {
  }

  public ngOnInit() {
    this.queryField.valueChanges.pipe(debounceTime(500))
      .subscribe(queryField => {
        if (queryField == null || queryField == '') {
          this.searchResults = null;
          return;
        }
        this.searching = true;
        this.pageContentService.search(null, queryField).subscribe(
          result => {
            this.searchResults = result as PageContent[];
          },
          error => { },
          () => {
            this.searching = false;
          }
        );
      });

    $(document)
      .on('keyup',
        event => {
          if (event.keyCode === 27) { // ESC
            this.closeNavSearch();
          }
        })
      .on('click',
        event => {
          if (!$.contains(this.elem.nativeElement, event.target)) {
            this.closeNavSearch();
          }
        });
  }

  public closeNavSearch() {
    this.visible = false;
    this.searching = false;
    this.queryField.reset();
    this.searchResults = null;
    this.onclose.emit();
  }

  public ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes['visible'].currentValue === true) {
      this.elem.nativeElement.querySelector('input').focus();
    }
  }

  public submitValue() {
    this.router.navigate(['/help/search'], { queryParams: { keyword: this.queryField.value } });
    this.closeNavSearch();
  }
}
